import { useState, useEffect } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Infinity as InfinityIcon } from 'lucide-react';

export default function ButtonGroupNumPreguntas({
  title = 'Numero de preguntas',
  value,
  onChange,
  modo,
  options = [20, 50, 100, 140, 280],
  enarmValue = 280,
  accentColor = '#6366f1',
  accentHoverColor = '#4f46e5',
}) {
  const [alignment, setAlignment] = useState(value);

  const normalizedOptions = (Array.isArray(options) ? options : []).reduce((acc, item) => {
    const parsed = Number(item);
    if (!Number.isFinite(parsed) || parsed < 0 || acc.includes(parsed)) {
      return acc;
    }

    acc.push(parsed);
    return acc;
  }, []);

  const finalOptions =
    modo === 'enarm' && !normalizedOptions.includes(enarmValue)
      ? [...normalizedOptions, enarmValue]
      : normalizedOptions;

  useEffect(() => {
    setAlignment(value);
  }, [value]);

  useEffect(() => {
    if (modo === 'enarm') {
      setAlignment(enarmValue);
      if (value !== enarmValue) {
        onChange(enarmValue);
      }
    }
  }, [modo, enarmValue, onChange, value]);

  const handleChange = (event, newAlignment) => {
    if (newAlignment === null) return;
    const parsed = Number(newAlignment);
    if (!Number.isFinite(parsed) || parsed < 0) return;
    setAlignment(parsed);
    onChange(parsed);
  };

  const buttonSx = {
    flex: 1,
    minWidth: 0,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    borderColor: 'transparent',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    px: { xs: 1, sm: 1.5 },
    py: { xs: 0.75, sm: 1 },
    fontSize: { xs: '0.75rem', sm: '0.875rem' },
    '&.Mui-selected': {
      backgroundColor: accentColor,
      color: 'secondary.contrastText',
      boxShadow: 'none',
      borderColor: 'transparent',
    },
    '&.Mui-selected:hover': {
      backgroundColor: accentHoverColor,
      color: 'secondary.contrastText',
      borderColor: 'transparent',
    },
  };

  return (
    <>
    <h3 className="text-sm font-semibold mb-2">{title}</h3>
    <ToggleButtonGroup
      color="secondary"
      value={alignment}
      exclusive
      onChange={handleChange}
      aria-label="Numero de preguntas"
      sx={{
        width: '100%',
        flexWrap: 'wrap',
        border: '1px solid #cbd5e1',
        borderRadius: '10px',
        overflow: 'hidden',
        '& .MuiToggleButtonGroup-grouped': {
          margin: 0,
          border: 0,
          borderRadius: 0,
        },
        '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
          borderRight: '1px solid #e2e8f0',
        },
      }}
      disabled={modo === 'enarm'}
    >
      {finalOptions.map((option) => (
        <ToggleButton
          key={option}
          value={option}
          sx={buttonSx}
          disabled={modo === 'enarm'}
        >
          {option === 0 ? <InfinityIcon size={18} /> : option}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    </>
  );
}